<template>
    <div class="container">
        <div class="header">
            <comSelect class="comSelect" :options="options" @clickOption="clickOptionItem" :choosed="currentOptionItem"></comSelect>
        </div>
        <div class="content">
            <div class="conList_title">
                <div class="item_no">序号</div>
                <div class="item_image">账号</div>
                <div class="item_time">反馈时间</div>
                <div class="item_type">类型</div>
                <div class="item_count">小程序</div>
                <div class="item_title">内容</div>
                <div class="operation">操作</div>
            </div>
            <div class="conList_items" v-for="(item, index) in list" :key="item.id">
                <div class="item_no">{{ index + 1 + (currentPage - 1) * pageSize }}</div>
                <div class="item_image">
                    {{ item.username }}
                </div>
                <div class="item_time">{{ formatDate(item.createdAt, "y/M/d h:m") }}</div>
                <div class="item_type">{{ item.type }}</div>
                <div class="item_count">{{ item.appVersion }}</div>
                <div class="item_title">
                    <div>{{ item.content }}</div>
                </div>
                <div class="operation">
                    <a @click="toDetail(item)">详情</a>
                </div>
            </div>
            <comPage class="comPage" :totalPage="totalPage" :currentPage="currentPage" @currentChange="currentChange"></comPage>
        </div>
    </div>
</template>

<script>
import comSelect from "../../components/comSelect";
import comPage from "../../components/comPage";
import { getFeedBackList } from "@/http/feedBack";
export default {
    name: "feedBack",
    components: {
        comSelect,
        comPage,
    },
    data() {
        return {
            pageSize: 10,
            list: [],
            totalPage: 1,
            currentPage: 1,
            searchInput: "",
            searchParam: "",
            currentOptionItem: "",
            options: [
                { name: "全部", value: "" },
                { name: "小程序问题", value: "小程序问题" },
                { name: "功能异常", value: "功能异常" },
                { name: "意见与建议", value: "意见与建议" },
                { name: "其他", value: "其他" },
            ],
        };
    },
    methods: {
        getList() {
            if (this.currentPage) {
                let httpData = {
                    pageId: this.currentPage - 1,
                    pageSize: this.pageSize,
                };
                if (this.currentOptionItem) {
                    httpData.type = this.currentOptionItem;
                }
                getFeedBackList(httpData)
                    .then((res) => {
                        console.log(res.data.result.content);
                        if (res.data.errCode === 0) {
                            this.list = res.data.result.content;
                            this.totalPage = res.data.result.totalPages;
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                    });
            }
        },
        addItem() {
            this.$router.push({ name: "" });
        },
        deleteItem(item) {
            layer.confirm("确定删除?", { title: "提示" }, (index1) => {
                layer.confirm("删除之后不可恢复，是否继续?", { title: "提示" }, (index2) => {
                    deleteFunction({
                        id: item.id,
                    }).then((res) => {
                        if (res.data.status == 1) {
                            this.getList();
                            layer.msg("删除成功");
                        }
                    });
                    layer.close(index2);
                });
                layer.close(index1);
            });
        },
        clickOptionItem(item) {
            if (this.currentOptionItem == item.value) {
                return;
            }
            this.currentOptionItem = item.value;
            let query = { ...this.$route.query };
            if (this.currentPage > 1) {
                this.currentPage = 1;
                query.currentPage = 1;
            }
            query.currentOptionItem = this.currentOptionItem;
            this.$router.replace({ query: query });
            this.getList();
        },
        currentChange(val) {
            if (this.currentPage == val) {
                return;
            }
            this.currentPage = val;
            let query = { ...this.$route.query };
            query.currentPage = this.currentPage;
            this.$router.replace({ query: query });
            this.getList();
        },
        searchInputSubmit() {
            if (this.searchInput) {
                this.searchParam = this.searchInput;
                let query = { ...this.$route.query };
                if (this.currentPage > 1) {
                    this.currentPage = 1;
                    query.currentPage = 1;
                }
                this.$router.replace({ query: query });
                this.getList();
            }
        },
        toDetail(item) {
            this.$router.push({ name: "feedbackDetail", query: item });
        },
    },
    watch: {},
    created() {
        this.currentPage = this.$route.query.currentPage || 1;
        this.currentOptionItem = this.$route.query.currentOptionItem || "";
        this.getList();
    },
};
</script>

<style lang="scss" scoped>
.content {
    width: 100%;
    min-height: 626px;
    padding-bottom: 76px;
    position: relative;
    .comPage {
        position: absolute;
        left: 0;
        bottom: 0;
    }
}
.comSelect {
    height: 36px;
    margin-right: 30px;
}
.conList_items {
    justify-content: space-between;
}
.item_no {
    flex: 0 0 100px;
}
.item_title {
    flex: 0 0 300px;
    max-width: 300px;
    div {
        display: block;
        width: 100%;
        padding: 0 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}
.item_image {
    flex: 0 0 200px;
    img {
        height: 80px;
    }
}
.item_time {
    flex: 0 0 130px;
    max-width: 130px;
}
.item_type {
    flex: 0 0 100px;
}
.item_count {
    flex: 0 0 100px;
}

@media only screen and (max-width: 1500px) {
    .item_no {
        flex: 0 0 80px;
    }
}
@media only screen and (max-width: 1400px) {
    .item_no {
        flex: 0 0 70px;
    }
    .item_title {
        flex: 0 0 200px;
        max-width: 200px;
    }
}
</style>
